var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpeedmeter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.574 36.514a.83.83 0 01-.743-.454 9.79 9.79 0 00-5.81-4.89c-.51-.155-1.03-.273-1.556-.353l-.108-.016 5.54-17.322.094.003c10.764 2.925 16.922 11.551 18.553 14.125a.832.832 0 01-.333 1.19l-15.263 7.628a.834.834 0 01-.374.089z",
    fill: "#DBDBDB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.276 39.808a1.481 1.481 0 100-2.962 1.481 1.481 0 000 2.962z",
    fill: "#282828"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.336 36.492a.832.832 0 01-.388-.097L.772 28.389a.832.832 0 01-.323-1.17 33.638 33.638 0 017.59-8.514c5.24-4.153 11.202-6.237 17.717-6.202 2.443.01 4.875.34 7.233.98l.093.024-5.541 17.321-.078-.012c-.5-.075-1.002-.12-1.507-.133-5.638-.16-8.082 3.68-8.87 5.338a.815.815 0 01-.486.428.841.841 0 01-.265.043z",
    fill: "#E95832"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.967 13.572l-3.918 17.51a11.172 11.172 0 00-1.57-.356l5.486-17.154h.002z",
    fill: "#282828"
  })));
}
export default __webpack_public_path__ + "static/media/speedmeter.61d56a5c.svg";
export { SvgSpeedmeter as ReactComponent };